<template>
  <div id="mktSales">
    <div class="mainFixed" style="box-shadow: 0px 0px 5px 0px #ccc;position:relative;top:0;width:calc(100% - 20px);">
      <div class="allSearch d_flex">
        <dl>
          <dd>
            <span class="f_w">{{$t('common.TopHospital')}}:</span>
            <div class="dis_line v_m">
              <hospitalSelect :cols="1" @submit="hospitalChange" :disabled="hospitalList&&hospitalList.length>0?false:true" :chooseData="hospitalList" :multiple="true" :needReturn="'Code'" :matchValue="'Name'" :showValue="'{{Name}}'" v-model="postData.types" :width="'100%'">
              </hospitalSelect>
            </div>
          </dd>
        </dl>
        <dl>
          <dt>
            <button class="redButton m_l_10" :disabled="!nsdData.CanExport" @click="downLoad()"><i class="icon iconfont icon-daochu"></i>{{$t('common.Export')}}</button>
          </dt>
        </dl>
      </div>
      <table style="table-layout: fixed;" id="noScroll" class="allTable" cellspacing="0">
        <thead>
        <tr>
          <th></th>
          <th>RSD</th>
          <th class="topNum"></th>
          <th>{{$t('common.Region')}}</th>
          <th></th>
          <th>{{$t('common.'+$commonJs.getMonthTh(month+0)+'M')}}{{$t('common.Forecast')}}</th>
          <th>{{$t('common.'+$commonJs.getMonthTh(month+1)+'M')}}{{$t('common.Forecast')}}</th>
          <th>{{$t('common.'+$commonJs.getMonthTh(month+2)+'M')}}{{$t('common.Forecast')}}</th>
          <th>{{$t('common.'+$commonJs.getMonthTh(month+3)+'M')}}{{$t('common.Forecast')}}</th>
          <th>{{$commonJs.getLastQuarter(month)}}{{$t('common.QuarterTotal')}}*</th>
<!--          <th>{{$commonJs.getLastQuarter(month)}}{{$t('common.RateAndQoQ')}}</th>-->
          <th>{{$commonJs.getQuarter(month)}}{{$t('common.QuarterTotal')}}</th>
          <th>{{$commonJs.getQuarter(month)}}{{$t('common.RateAndQoQ')}}</th>
<!--          <th>{{$t('common.YTDRate')}}*</th>-->
          <th>{{$t('common.Submitter')}}</th>
          <th>{{$t('common.Status')}}</th>
        </tr>
        </thead>
        <tbody>
        <tr style="background-color: #F9F9F9;" class="colorRed f_w" v-if="nsdData">
          <td></td>
          <td>{{nsdData.Title}}</td>
          <td class="topNum"></td>
          <td style="max-width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" class="c_p" @click="areaEvent('all')">{{nsdData.Area}}</td>
          <td></td>
          <td>{{$commonJs.numFixed(nsdData.CurrentMonth)}}</td>
          <td>{{$commonJs.numFixed(nsdData.SecondMonth)}}</td>
          <td>{{$commonJs.numFixed(nsdData.ThirdMonth)}}</td>
          <td>{{$commonJs.numFixed(nsdData.FourthMonth)}}</td>
          <td>{{$commonJs.numFixed(nsdData.LastQuarter)}}</td>
<!--          <td>{{nsdData.LastQuarterRate==-1?'&#45;&#45;':Math.round(nsdData.LastQuarterRate*1000)/10+'%'}}{{'('+(nsdData.LastQuarterOnQuarterRatio==-1?'&#45;&#45;)':Math.round(nsdData.LastQuarterOnQuarterRatio*100)+'%)')}}</td>-->
          <td>{{$commonJs.numFixed(nsdData.CurrentQuarter)}}</td>
          <td>{{nsdData.CurrentQuarterRate==-1?'--':Math.round(nsdData.CurrentQuarterRate*1000)/10+'%'}}{{'('+(nsdData.QuarterOnQuraterRatio==-1?'--)':Math.round(nsdData.QuarterOnQuraterRatio*100)+'%)')}}</td>
<!--          <td>{{nsdData.YTD==-1?'— —':Math.round(nsdData.YTD*1000)/10+'%'}}</td>-->
          <td>{{nsdData.SubmittedBy?nsdData.SubmittedBy:''}}</td>
          <td></td>
        </tr>
        <tr v-if="nsdData&&postData.hospital!=''" style="background-color: #F9F9F9;" class="colorRed f_w">
          <td></td>
          <td>{{$t('common.TopHospital')}}{{$t('common.QuarterTotal')}}</td>
          <td class="topNum"></td>
          <td style="max-width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{showTopHospital}}</td><!-- class="c_p" @click="areaEvent('all')"-->
          <td></td>
          <td>{{$commonJs.numFixed(nsdData.CurrentMonthByHospitalTypes)}}</td>
          <td>{{$commonJs.numFixed(nsdData.SecondMonthByHospitalTypes)}}</td>
          <td>{{$commonJs.numFixed(nsdData.ThirdMonthByHospitalTypes)}}</td>
          <td>{{$commonJs.numFixed(nsdData.FourthMonthByHospitalTypes)}}</td>
          <td>{{$commonJs.numFixed(nsdData.LastQuarterByHospitalTypes)}}</td>
          <td>{{$commonJs.numFixed(nsdData.CurrentQuarterByHospitalTypes)}}</td>
          <td>{{nsdData.CurrentQuarterRateByHospitalTypes==-1?'--':Math.round(nsdData.CurrentQuarterRateByHospitalTypes*1000)/10+'%'}}{{'('+(nsdData.QuarterOnQuraterRatioByHospitalTypes==-1?'--)':Math.round(nsdData.QuarterOnQuraterRatioByHospitalTypes*100)+'%)')}}</td>
          <td></td>
          <td></td>
        </tr>
        </tbody>
      </table>
    </div>
    <div ref="mainScroll" class="mainScroll" :style="showChartFlag?'margin-bottom: 190px;height: 150px;':'margin-bottom: 20px;height: 320px;'" style="overflow: scroll;">
      <table style="table-layout: fixed;" class="allTable" cellspacing="0">
        <tbody :key="index" v-for="(item, index) in nsdData.ChildrenList" v-if="nsdData.ChildrenList&&nsdData.ChildrenList.length > 0">
          <tr>
            <td :class="item.Expendable?'expend_able':'expend_disable'" @click="item.Expendable?expendRow(item.TerritoryCode,index):''">{{postData.hospital==''?(expendRowCode == item.TerritoryCode?$t('common.PackUp')+'>':$t('common.Expand')):''}}</td>
            <td>{{item.Title}}</td>
            <td class="topNum">{{item.Type}}</td>
            <td>
              <span @click="postData.hospital==''?areaEvent(item):hospitalEvent(item)" :class="postData.hospital==''?'c_p':'greenA c_p'">{{item.Area}}</span>
            </td>
            <td><tsName :value="item.EmployeeNames"></tsName></td>
            <td v-if="item.Visible" class="salesBorder" :class="item.canEdit?'editBC':''">
              <div :class="item.IsModifiedCurrentMonth?'bgRed':''" style="display: flex;justify-content: space-between;align-items: center;">
                <div style="display: flex;align-items: center;">
                  <editCom :canEdit="item.canEdit" :value="item.CurrentMonth" v-model="item.CurrentMonth"></editCom>
                  <i v-if="postData.hospital!='' && $commonJs.isShowHigh(item.LastMonthMinuTwoSalesAmount,item.LastMonthMinuOneSalesAmount,item.LastMonthSalesAmount,item.CurrentMonth)" class="icon iconfont icon-wanjiantou-"></i>
                  <i v-if="postData.hospital!='' && $commonJs.isShowLow(item.LastMonthMinuTwoSalesAmount,item.LastMonthMinuOneSalesAmount,item.LastMonthSalesAmount,item.CurrentMonth)" class="icon iconfont icon-wanjiantou"></i>
                </div>
                <reason v-if="item.Reasons" v-model="item.Reasons.CurrentMonth" :canEdit="item.canEdit" @changeValue="changeReason"></reason>
              </div>
              <div :class="$commonJs.isShowHigh(item.LastMonthMinuTwoSalesAmount,item.LastMonthMinuOneSalesAmount,item.LastMonthSalesAmount,item.CurrentMonth)?'colorGreen':($commonJs.isShowLow(item.LastMonthMinuTwoSalesAmount,item.LastMonthMinuOneSalesAmount,item.LastMonthSalesAmount,item.CurrentMonth)?'colorRed':'')"
                   v-if="item.Reasons&&item.Reasons.CurrentMonth"><showReason v-model="item.Reasons.CurrentMonth"></showReason></div>
            </td>
            <td v-else class="salesBorder">— —</td>
            <td v-if="item.Visible" :class="item.canEdit?'editBC':''">
              <div :class="item.IsModifiedSecondMonth?'bgRed':''" style="display: flex;justify-content: space-between;align-items: center;">
                <div style="display: flex;align-items: center;">
                  <editCom :canEdit="item.canEdit" :value="item.SecondMonth" v-model="item.SecondMonth"></editCom>
                  <i v-if="postData.hospital!=''&& $commonJs.isShowHigh(item.CurrentMonth,item.LastMonthMinuOneSalesAmount,item.LastMonthSalesAmount,item.SecondMonth)" class="icon iconfont icon-wanjiantou-"></i>
                  <i v-if="postData.hospital!=''&& $commonJs.isShowLow(item.CurrentMonth,item.LastMonthMinuOneSalesAmount,item.LastMonthSalesAmount,item.SecondMonth)" class="icon iconfont icon-wanjiantou"></i>
                </div>
                <reason v-if="item.Reasons" v-model="item.Reasons.SecondMonth" :canEdit="item.canEdit" @changeValue="changeReason"></reason>
              </div>
              <div :class="$commonJs.isShowHigh(item.CurrentMonth,item.LastMonthMinuOneSalesAmount,item.LastMonthSalesAmount,item.SecondMonth)?'colorGreen':($commonJs.isShowLow(item.CurrentMonth,item.LastMonthMinuOneSalesAmount,item.LastMonthSalesAmount,item.SecondMonth)?'colorRed':'')"
                   v-if="item.Reasons&&item.Reasons.SecondMonth"><showReason v-model="item.Reasons.SecondMonth"></showReason></div>
            </td>
            <td v-else>— —</td>
            <td v-if="item.Visible" :class="item.canEdit?'editBC':''">
              <div :class="item.IsModifiedThirdMonth?'bgRed':''" style="display: flex;justify-content: space-between;align-items: center;">
                <div style="display: flex;align-items: center;">
                  <editCom :canEdit="item.canEdit" :value="item.ThirdMonth" v-model="item.ThirdMonth"></editCom>
                  <i v-if="postData.hospital!=''&& $commonJs.isShowHigh(item.CurrentMonth,item.SecondMonth,item.LastMonthSalesAmount,item.ThirdMonth)" class="icon iconfont icon-wanjiantou-"></i>
                  <i v-if="postData.hospital!=''&& $commonJs.isShowLow(item.CurrentMonth,item.SecondMonth,item.LastMonthSalesAmount,item.ThirdMonth)" class="icon iconfont icon-wanjiantou"></i>
                </div>
                <reason v-if="item.Reasons" v-model="item.Reasons.ThirdMonth" :canEdit="item.canEdit" @changeValue="changeReason"></reason>
              </div>
              <div :class="$commonJs.isShowHigh(item.CurrentMonth,item.SecondMonth,item.LastMonthSalesAmount,item.ThirdMonth)?'colorGreen':($commonJs.isShowLow(item.CurrentMonth,item.SecondMonth,item.LastMonthSalesAmount,item.ThirdMonth)?'colorRed':'')"
                   v-if="item.Reasons&&item.Reasons.ThirdMonth"><showReason v-model="item.Reasons.ThirdMonth"></showReason></div>
            </td>
            <td v-else>— —</td>
            <td v-if="item.Visible" :class="item.canEdit?'editBC':''">
              <div :class="item.IsModifiedFourthMonth?'bgRed':''" style="display: flex;justify-content: space-between;align-items: center;">
                <div style="display: flex;align-items: center;">
                  <editCom :canEdit="item.canEdit" :value="item.FourthMonth" v-model="item.FourthMonth"></editCom>
                  <i v-if="$commonJs.isShowHigh(item.CurrentMonth,item.SecondMonth,item.ThirdMonth,item.FourthMonth)" class="icon iconfont icon-wanjiantou-"></i>
                  <i v-if="$commonJs.isShowLow(item.CurrentMonth,item.SecondMonth,item.ThirdMonth,item.FourthMonth)" class="icon iconfont icon-wanjiantou"></i>
                </div>
                <reason v-if="item.Reasons" v-model="item.Reasons.FourthMonth" :canEdit="item.canEdit" @changeValue="changeReason"></reason>
              </div>
              <div :class="$commonJs.isShowHigh(item.CurrentMonth,item.SecondMonth,item.ThirdMonth,item.FourthMonth)?'colorGreen':($commonJs.isShowLow(item.CurrentMonth,item.SecondMonth,item.ThirdMonth,item.FourthMonth)?'colorRed':'')"
                   v-if="item.Reasons&&item.Reasons.FourthMonth"><showReason v-model="item.Reasons.FourthMonth"></showReason></div>
            </td>
            <td v-else>— —</td>
            <td v-if="item.Visible">{{$commonJs.numFixed(item.LastQuarter)}}</td>
            <td v-else>— —</td>
<!--              <td v-if="item.Visible">-->
<!--                {{item.LastQuarterRate==-1?'&#45;&#45;':Math.round(item.LastQuarterRate*1000)/10+'%'}}-->
<!--                {{'('+(item.LastQuarterOnQuarterRatio==-1?'&#45;&#45;)':Math.round(item.LastQuarterOnQuarterRatio*100)+'%)')}}-->
<!--              </td>-->
<!--              <td v-else>— —</td>-->
            <td v-if="item.Visible">{{$commonJs.numFixed(item.CurrentQuarter)}}</td>
            <td v-else>— —</td>
            <td v-if="item.Visible">
              {{item.CurrentQuarterRate==-1?'--':Math.round(item.CurrentQuarterRate*1000)/10+'%'}}
              {{'('+(item.QuarterOnQuraterRatio==-1?'--)':Math.round(item.QuarterOnQuraterRatio*100)+'%)')}}
            </td>
            <td v-else>— —</td>
<!--              <td v-if="item.Visible">{{item.YTD==-1?'— —':Math.round(item.YTD*1000)/10+'%'}}</td>-->
<!--              <td v-else>— —</td>-->
            <td>{{item.SubmittedBy?item.SubmittedBy:''}}</td>
            <td>{{postData.hospital==''&&!hideBtn?item.Status:''}}</td>
          </tr>
          <tr>
            <td colspan="14" style="padding: 0">
              <table style="table-layout: fixed;" class="allTable" cellspacing="0" v-if="expendRowCode==item.TerritoryCode" :key="k" v-for="(sItem, k) in item.child">
                <tr style="background-color: #F8F8F8;">
                  <td style="padding-left: 20px" :class="sItem.Expendable?'expend_able':'expend_disable'" @click="sItem.Expendable?expendSubRow(sItem.TerritoryCode,index,k):''">{{postData.hospital==''?(expendSubRowCode == sItem.TerritoryCode?$t('common.PackUp')+'>':$t('common.Expand')):''}}</td>
                  <td>{{sItem.Title}}</td>
                  <td class="topNum">{{sItem.Type}}</td>
                  <td>
                    <span @click="postData.hospital==''?areaEvent(sItem):hospitalEvent(sItem)" :class="postData.hospital==''?'c_p':'greenA c_p'">{{sItem.Area}}</span>
                  </td>
                  <td><tsName :value="sItem.EmployeeNames"></tsName></td>
                  <td class="salesBorder" :class="sItem.canEdit?'editBC':''">
                    <div style="display: flex;justify-content: space-between;align-sitems: center;">
                      <div style="display: flex;align-sitems: center;">
                        <editCom :canEdit="sItem.canEdit" :value="sItem.CurrentMonth" v-model="sItem.CurrentMonth"></editCom>
                      </div>
                      <reason v-if="sItem.Reasons" v-model="sItem.Reasons.CurrentMonth" :canEdit="sItem.canEdit" @changeValue="changeReason"></reason>
                    </div>
                  </td>
                  <td :class="sItem.canEdit?'editBC':''">
                    <div style="display: flex;justify-content: space-between;align-sitems: center;">
                      <div style="display: flex;align-sitems: center;">
                        <editCom :canEdit="sItem.canEdit" :value="sItem.SecondMonth" v-model="sItem.SecondMonth"></editCom>
                      </div>
                      <reason v-if="sItem.Reasons" v-model="sItem.Reasons.SecondMonth" :canEdit="sItem.canEdit" @changeValue="changeReason"></reason>
                    </div>
                  </td>
                  <td :class="sItem.canEdit?'editBC':''">
                    <div style="display: flex;justify-content: space-between;align-sitems: center;">
                      <div style="display: flex;align-sitems: center;">
                        <editCom :canEdit="sItem.canEdit" :value="sItem.ThirdMonth" v-model="sItem.ThirdMonth"></editCom>
                      </div>
                      <reason v-if="sItem.Reasons" v-model="sItem.Reasons.ThirdMonth" :canEdit="sItem.canEdit" @changeValue="changeReason"></reason>
                    </div>
                  </td>
                  <td :class="sItem.canEdit?'editBC':''">
                    <div style="display: flex;justify-content: space-between;align-sitems: center;">
                      <div style="display: flex;align-sitems: center;">
                        <editCom :canEdit="sItem.canEdit" :value="sItem.FourthMonth" v-model="sItem.FourthMonth"></editCom>
                      </div>
                      <reason v-if="sItem.Reasons" v-model="sItem.Reasons.FourthMonth" :canEdit="sItem.canEdit" @changeValue="changeReason"></reason>
                    </div>
                  </td>
                  <td>{{$commonJs.numFixed(sItem.LastQuarter)}}</td>
      <!--                <td>-->
      <!--                  {{sItem.LastQuarterRate==-1?'&#45;&#45;':Math.round(sItem.LastQuarterRate*1000)/10+'%'}}-->
      <!--                  {{'('+(sItem.LastQuarterOnQuarterRatio==-1?'&#45;&#45;)':Math.round(sItem.LastQuarterOnQuarterRatio*100)+'%)')}}-->
      <!--                </td>-->
                  <td>{{$commonJs.numFixed(sItem.CurrentQuarter)}}</td>
                  <td>
                    {{sItem.CurrentQuarterRate==-1?'--':Math.round(sItem.CurrentQuarterRate*1000)/10+'%'}}
                    {{'('+(sItem.QuarterOnQuraterRatio==-1?'--)':Math.round(sItem.QuarterOnQuraterRatio*100)+'%)')}}
                  </td>
      <!--                <td>{{sItem.YTD==-1?'— —':Math.round(sItem.YTD*1000)/10+'%'}}</td>-->
                  <td>{{sItem.SubmittedBy?sItem.SubmittedBy:''}}</td>
                  <td></td>
                </tr>
                <tr v-if="expendSubRowCode==sItem.TerritoryCode" :key="j" v-for="(subItem, j) in sItem.child">
                  <td></td>
                  <td>{{subItem.Title}}</td>
                  <td class="topNum">{{subItem.Type}}</td>
                  <td>
                    <span @click="hospitalEvent(subItem)" class="greenA c_p">{{subItem.Area}}</span>
                  </td>
                  <td><tsName :value="subItem.EmployeeNames"></tsName></td>
                  <td class="salesBorder" :class="subItem.canEdit?'editBC':''">
                    <div :class="subItem.IsModifiedCurrentMonth?'bgRed':''" style="display: flex;justify-content: space-between;align-items: center;">
                      <div style="display: flex;align-items: center;">
                        <editCom :canEdit="subItem.canEdit" :value="subItem.CurrentMonth" v-model="subItem.CurrentMonth"></editCom>
                        <i v-if="$commonJs.isShowHigh(subItem.LastMonthMinuTwoSalesAmount,subItem.LastMonthMinuOneSalesAmount,subItem.LastMonthSalesAmount,subItem.CurrentMonth)" class="icon iconfont icon-wanjiantou-"></i>
                        <i v-if="$commonJs.isShowLow(subItem.LastMonthMinuTwoSalesAmount,subItem.LastMonthMinuOneSalesAmount,subItem.LastMonthSalesAmount,subItem.CurrentMonth)" class="icon iconfont icon-wanjiantou"></i>
                      </div>
                      <reason v-if="subItem.Reasons" v-model="subItem.Reasons.CurrentMonth" :canEdit="subItem.canEdit" @changeValue="changeReason"></reason>
                    </div>
                    <div :class="$commonJs.isShowHigh(subItem.LastMonthMinuTwoSalesAmount,subItem.LastMonthMinuOneSalesAmount,subItem.LastMonthSalesAmount,subItem.CurrentMonth)?'colorGreen':($commonJs.isShowLow(subItem.LastMonthMinuTwoSalesAmount,subItem.LastMonthMinuOneSalesAmount,subItem.LastMonthSalesAmount,subItem.CurrentMonth)?'colorRed':'')"
                         v-if="subItem.Reasons&&subItem.Reasons.CurrentMonth"><showReason v-model="subItem.Reasons.CurrentMonth"></showReason></div>
                  </td>
                  <td :class="subItem.canEdit?'editBC':''">
                    <div :class="subItem.IsModifiedSecondMonth?'bgRed':''" style="display: flex;justify-content: space-between;align-items: center;">
                      <div style="display: flex;align-items: center;">
                        <editCom :canEdit="subItem.canEdit" :value="subItem.SecondMonth" v-model="subItem.SecondMonth"></editCom>
                        <i v-if="$commonJs.isShowHigh(subItem.CurrentMonth,subItem.LastMonthMinuOneSalesAmount,subItem.LastMonthSalesAmount,subItem.SecondMonth)" class="icon iconfont icon-wanjiantou-"></i>
                        <i v-if="$commonJs.isShowLow(subItem.CurrentMonth,subItem.LastMonthMinuOneSalesAmount,subItem.LastMonthSalesAmount,subItem.SecondMonth)" class="icon iconfont icon-wanjiantou"></i>
                      </div>
                      <reason v-if="subItem.Reasons" v-model="subItem.Reasons.SecondMonth" :canEdit="subItem.canEdit" @changeValue="changeReason"></reason>
                    </div>
                    <div :class="$commonJs.isShowHigh(subItem.CurrentMonth,subItem.LastMonthMinuOneSalesAmount,subItem.LastMonthSalesAmount,subItem.SecondMonth)?'colorGreen':($commonJs.isShowLow(subItem.CurrentMonth,subItem.LastMonthMinuOneSalesAmount,subItem.LastMonthSalesAmount,subItem.SecondMonth)?'colorRed':'')"
                         v-if="subItem.Reasons&&subItem.Reasons.SecondMonth"><showReason v-model="subItem.Reasons.SecondMonth"></showReason></div>
                  </td>
                  <td :class="subItem.canEdit?'editBC':''">
                    <div :class="subItem.IsModifiedThirdMonth?'bgRed':''" style="display: flex;justify-content: space-between;align-items: center;">
                      <div style="display: flex;align-items: center;">
                        <editCom :canEdit="subItem.canEdit" :value="subItem.ThirdMonth" v-model="subItem.ThirdMonth"></editCom>
                        <i v-if="$commonJs.isShowHigh(subItem.CurrentMonth,subItem.SecondMonth,subItem.LastMonthSalesAmount,subItem.ThirdMonth)" class="icon iconfont icon-wanjiantou-"></i>
                        <i v-if="$commonJs.isShowLow(subItem.CurrentMonth,subItem.SecondMonth,subItem.LastMonthSalesAmount,subItem.ThirdMonth)" class="icon iconfont icon-wanjiantou"></i>
                      </div>
                      <reason v-if="subItem.Reasons" v-model="subItem.Reasons.ThirdMonth" :canEdit="subItem.canEdit" @changeValue="changeReason"></reason>
                    </div>
                    <div :class="$commonJs.isShowHigh(subItem.CurrentMonth,subItem.SecondMonth,subItem.LastMonthSalesAmount,subItem.ThirdMonth)?'colorGreen':($commonJs.isShowLow(subItem.CurrentMonth,subItem.SecondMonth,subItem.LastMonthSalesAmount,subItem.ThirdMonth)?'colorRed':'')"
                         v-if="subItem.Reasons&&subItem.Reasons.ThirdMonth"><showReason v-model="subItem.Reasons.ThirdMonth"></showReason></div>
                  </td>
                  <td :class="subItem.canEdit?'editBC':''">
                    <div :class="subItem.IsModifiedFourthMonth?'bgRed':''" style="display: flex;justify-content: space-between;align-items: center;">
                      <div style="display: flex;align-items: center;">
                        <editCom :canEdit="subItem.canEdit" :value="subItem.FourthMonth" v-model="subItem.FourthMonth"></editCom>
                        <i v-if="$commonJs.isShowHigh(subItem.CurrentMonth,subItem.SecondMonth,subItem.ThirdMonth,subItem.FourthMonth)" class="icon iconfont icon-wanjiantou-"></i>
                        <i v-if="$commonJs.isShowLow(subItem.CurrentMonth,subItem.SecondMonth,subItem.ThirdMonth,subItem.FourthMonth)" class="icon iconfont icon-wanjiantou"></i>
                      </div>
                      <reason v-if="subItem.Reasons" v-model="subItem.Reasons.FourthMonth" :canEdit="subItem.canEdit" @changeValue="changeReason"></reason>
                    </div>
                    <div :class="$commonJs.isShowHigh(subItem.CurrentMonth,subItem.SecondMonth,subItem.ThirdMonth,subItem.FourthMonth)?'colorGreen':($commonJs.isShowLow(subItem.CurrentMonth,subItem.SecondMonth,subItem.ThirdMonth,subItem.FourthMonth)?'colorRed':'')"
                         v-if="subItem.Reasons&&subItem.Reasons.FourthMonth"><showReason v-model="subItem.Reasons.FourthMonth"></showReason></div>
                  </td>
                  <td>{{$commonJs.numFixed(subItem.LastQuarter)}}</td>
      <!--                <td>-->
      <!--                  {{subItem.LastQuarterRate==-1?'&#45;&#45;':Math.round(subItem.LastQuarterRate*1000)/10+'%'}}-->
      <!--                  {{'('+(subItem.LastQuarterOnQuarterRatio==-1?'&#45;&#45;)':Math.round(subItem.LastQuarterOnQuarterRatio*100)+'%)')}}-->
      <!--                </td>-->
                  <td>{{$commonJs.numFixed(subItem.CurrentQuarter)}}</td>
                  <td>
                    {{subItem.CurrentQuarterRate==-1?'--':Math.round(subItem.CurrentQuarterRate*1000)/10+'%'}}
                    {{'('+(subItem.QuarterOnQuraterRatio==-1?'--)':Math.round(subItem.QuarterOnQuraterRatio*100)+'%)')}}
                  </td>
      <!--                <td>{{subItem.YTD==-1?'— —':Math.round(subItem.YTD*1000)/10+'%'}}</td>-->
                  <td>{{subItem.SubmittedBy?subItem.SubmittedBy:''}}</td>
                  <td></td>
                </tr>
              </table>
            </td>
          </tr>
        </tbody>
        <tbody v-if="!nsdData.ChildrenList||nsdData.ChildrenList.length == 0">
          <tr>
            <td colspan="14" class="t_c colorGray bot_bottom">{{$t('common.noData')}}</td>
          </tr>
        </tbody>
      </table>
      <page v-if="postData.hospital!=''&&nsdData.ChildrenList&&nsdData.ChildrenList.length>0" :totalPage="Math.ceil(nsdData.Total/pageSize)" :page="pageIndex" @on-getList="changePage"></page>
    </div>
    <div style="position: relative;height: 1px;"></div>
    <div class="chartArea" :class="showChartFlag?'show':'hide'" style="width: calc(96% - 30px);left:50%;transform: translateX(-50%);overflow: hidden;">
      <button class="chartButton" @click="showChart()">{{showChartFlag?$t('common.Hide'):$t('common.Expand')}}</button>
      <div id="Charts"></div>
    </div>
  </div>
</template>

<script>
// let timePage
export default {
  name: 'mktSales',
  data () {
    return {
      pageIndex: 1,
      pageSize: 10,
      height: 0,
      hospitalList: [],
      showTopHospital: '',
      postData: {
        brandCode: '',
        hospital: '',
        hospitalCodes: '',
        asmCode: '',
        role: 'NSD',
        SalesOrMarketing: 'Market',
        types: ''
      },
      postRejectData: {
        territoryCode: '',
        brandCode: '',
        comment: ''
      },
      showHospitalName: '',
      areaName: this.$t('common.AllTotal'),
      brandList: [],
      brandName: '',
      nsdData: false,
      chartData: [],
      showChartFlag: true,
      expendRowCode: false,
      expendSubRowCode: false,
      dialogData: false,
      showDialog: false,
      rejectInfo: '',
      showRejectDialog: false,
      showChangeDialog: false,
      changeNsdData: [],
      hideBtn: false,
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1
    }
  },
  created () {
    if (sessionStorage.mktSalesParam && sessionStorage.mktSalesParam !== '') {
      let mktSalesParam = JSON.parse(sessionStorage.mktSalesParam)
      this.brandName = mktSalesParam.brandName || ''
      this.year = mktSalesParam.year || new Date().getFullYear()
      this.month = mktSalesParam.month || new Date().getMonth() + 1
      if (mktSalesParam.brandCode && mktSalesParam.brandCode !== '') {
        this.postData.brandCode = mktSalesParam.brandCode
        if (this.postData.brandCode.indexOf('_') !== -1) {
          this.hideBtn = true
        } else {
          this.hideBtn = false
        }
        this.getHospitalList()
      }
    }
  },
  destroyed () {
  },
  mounted () {
  },
  methods: {
    getHospitalList () {
      this.postData.hospital = ''
      this.postData.types = ''
      this.hospitalList = []
      let data = JSON.parse(JSON.stringify(this.postData))
      let url = this.$commonJs.returnQuery('/api/v1/admin/hospital/list', data)
      this.$axiox.get(url).then(msg => {
        this.postData.hospitalCodes = ''
        if (msg.data && msg.data.length > 0) {
          msg.data.unshift({Code: '', Name: this.$i18n.t('common.All')})
          this.hospitalList = msg.data || []
          this.showHospitalName = this.$i18n.t('common.All')
          this.getNsdList()
        }
      })
    },
    changePage (val) {
      this.pageIndex = val
      this.getNsdList(true, true)
    },
    getNsdList (isHospitalChange, isChangePage) {
      if (!isChangePage) {
        this.pageIndex = 1
      } else {
        this.nsdData = false
      }
      let data = JSON.parse(JSON.stringify(this.postData))
      if (this.postData.hospital !== '') {
        data.pageIndex = this.pageIndex
        data.pageSize = this.pageSize
      }
      let url = this.$commonJs.returnQuery('/api/v1/admin/nsdForecast/list', data)
      this.$axiox.get(url).then(msg => {
        if (msg.data && msg.data.ChildrenList) {
          msg.data.ChildrenList.forEach((item, index) => {
            if (item.RejectInfo) {
              msg.data.ChildrenList[index].rejectObj = {ShowReason: this.$t('common.ReturnedComments'), Comment: item.RejectInfo}
            }
            // msg.data.ChildrenList[index].canEdit = false
            if (this.postData.hospital !== '') {
              msg.data.ChildrenList[index].Reasons = {
                CurrentMonth: {ReasonCode: item.CurrentMonthReasonCode, Comment: item.CurrentMonthComment, ShowReason: this.getShowReason(item.CurrentMonthReasonCode)},
                SecondMonth: {ReasonCode: item.SecondMonthReasonCode, Comment: item.SecondMonthComment, ShowReason: this.getShowReason(item.SecondMonthReasonCode)},
                ThirdMonth: {ReasonCode: item.ThirdMonthReasonCode, Comment: item.ThirdMonthComment, ShowReason: this.getShowReason(item.ThirdMonthReasonCode)},
                FourthMonth: {ReasonCode: item.FourthMonthReasonCode, Comment: item.FourthMonthComment, ShowReason: this.getShowReason(item.FourthMonthReasonCode)}
              }
            }
            if (this.expendRowCode === item.TerritoryCode) {
              this.getNsdTsList(item.TerritoryCode, index)
            }
          })
        }
        this.nsdData = msg.data || {}
        if (!isChangePage) {
          this.getChartData(isHospitalChange)
        }
      })
    },
    getNsdTsList (territoryCode, index) {
      let data = JSON.parse(JSON.stringify(this.postData))
      data.territoryCode = territoryCode
      let url = this.$commonJs.returnQuery('/api/v1/admin/nsdForecast/asm/list', data)
      this.$axiox.get(url).then(msg => {
        this.$set(this.nsdData.ChildrenList[index], 'child', msg.data)
      })
    },
    getNsdSubTsList (territoryCode, index, k) {
      let data = JSON.parse(JSON.stringify(this.postData))
      data.territoryCode = territoryCode
      let url = this.$commonJs.returnQuery('/api/v1/admin/nsdForecast/ts/list', data)
      this.$axiox.get(url).then(msg => {
        if (msg.data && msg.data.length > 0) {
          msg.data.forEach((val, i) => {
            // msg.data[i].canEdit = false
            msg.data[i].Reasons = {
              CurrentMonth: {ReasonCode: val.CurrentMonthReasonCode, Comment: val.CurrentMonthComment, ShowReason: this.getShowReason(val.CurrentMonthReasonCode)},
              SecondMonth: {ReasonCode: val.SecondMonthReasonCode, Comment: val.SecondMonthComment, ShowReason: this.getShowReason(val.SecondMonthReasonCode)},
              ThirdMonth: {ReasonCode: val.ThirdMonthReasonCode, Comment: val.ThirdMonthComment, ShowReason: this.getShowReason(val.ThirdMonthReasonCode)},
              FourthMonth: {ReasonCode: val.FourthMonthReasonCode, Comment: val.FourthMonthComment, ShowReason: this.getShowReason(val.FourthMonthReasonCode)}
            }
          })
        }
        this.$set(this.nsdData.ChildrenList[index].child[k], 'child', msg.data)
      })
    },
    expendRow (territoryCode, index) {
      if (this.expendRowCode && this.expendRowCode === territoryCode) {
        this.expendRowCode = false
      } else {
        this.expendRowCode = territoryCode
        if (!this.nsdData.ChildrenList[index].child) {
          this.getNsdTsList(territoryCode, index)
        }
      }
    },
    expendSubRow (territoryCode, index, k) {
      if (this.expendSubRowCode && this.expendSubRowCode === territoryCode) {
        this.expendSubRowCode = false
      } else {
        this.expendSubRowCode = territoryCode
        if (!this.nsdData.ChildrenList[index].child[k].child) {
          this.getNsdSubTsList(territoryCode, index, k)
        }
      }
    },
    getChartData (isHospitalChange) {
      let data = JSON.parse(JSON.stringify(this.postData))
      if (isHospitalChange) {
        data.hospitalCodes = ''
        // data.hospital = ''
      }
      let url = this.$commonJs.returnQuery('/api/v1/admin/chartdata', data)
      this.$axiox.get(url).then(msg => {
        if (msg.data) {
          let datas = {}
          let monthList = []
          let actualList = []
          let forecastList = []
          let targetList = []
          let completionList = []
          if (msg.data.ActualSalesAndForecastList && msg.data.ActualSalesAndForecastList.length > 0) {
            msg.data.ActualSalesAndForecastList.forEach((a, i) => {
              monthList.push(a.YearMonth)
              if (i < 6) {
                actualList.push(a.Value)
                forecastList.push(null)
              } else {
                actualList.push(null)
                forecastList.push(a.Value)
              }
            })
          }
          if (msg.data.TargetList && msg.data.TargetList.length > 0) {
            msg.data.TargetList.forEach((a, i) => {
              targetList.push(a.Value)
            })
          }
          if (msg.data.CompletionPercentageList && msg.data.CompletionPercentageList.length > 0) {
            msg.data.CompletionPercentageList.forEach(a => {
              if (a.Value != null) {
                completionList.push(Math.round(a.Value * 1000) / 10)
              } else {
                completionList.push(null)
              }
            })
          }
          datas.monthList = monthList
          datas.actualList = actualList
          datas.forecastList = forecastList
          datas.targetList = targetList
          datas.completionList = completionList
          this.chartData = datas
          this.$chart.asmChart('Charts', this.brandName + '-' + this.areaName + '-' + this.showHospitalName, this.chartData)
        }
      })
    },
    downLoad () {
      let data = JSON.parse(JSON.stringify(this.postData))
      let url = this.$commonJs.returnQuery('/api/v1/admin/nsdForecast/export', data)
      this.$axiox.get(url).then(res => {
        location.href = res.data.FileURL
        this.$commonJs.alertTips({
          type: 'success',
          content: this.$t('common.ExportSuccess'),
          stayTime: 5
        })
      })
    },
    hospitalChange (data) {
      this.postData.hospital = this.postData.types
      this.showTopHospital = data
      this.showHospitalName = this.$i18n.t('common.All')
      this.nsdData = false
      this.expendRowCode = false
      this.postData.asmCode = ''
      this.areaName = this.$t('common.AllTotal')
      this.postData.hospitalCodes = this.postData.hospital
      this.getNsdList(true)
    },
    areaEvent (data) {
      if (data === 'all') {
        this.postData.asmCode = ''
        this.postData.hospitalCodes = ''
        this.showHospitalName = this.$i18n.t('common.All')
        this.areaName = this.$t('common.AllTotal')
      } else {
        this.postData.asmCode = data.TerritoryCode
        this.postData.hospitalCodes = ''
        this.showHospitalName = this.$i18n.t('common.All')
        this.areaName = data.Area
      }
      this.getChartData()
    },
    hospitalEvent (data) {
      this.postData.asmCode = ''
      this.areaName = this.$t('common.AllTotal')
      this.postData.hospitalCodes = data.HospitalCode
      this.showHospitalName = data.Area
      this.getChartData()
    },
    showChart () {
      if (this.showChartFlag) {
        this.showChartFlag = false
      } else {
        this.showChartFlag = true
      }
    },
    getShowReason (rCode) {
      switch (rCode) {
        case '1':
          return this.$t('common.Reason1')
        case '2':
          return this.$t('common.Reason2')
        case '3':
          return this.$t('common.Reason3')
        case '4':
          return this.$t('common.Reason4')
        case '5':
          return this.$t('common.Reason5')
        case '6':
          return this.$t('common.Reason6')
        case '7':
          return this.$t('common.Reason7')
      }
    }
  }
}
</script>

<style scoped>
  .for_i{
    display: contents;
  }
  .salesBorder{
    border-left: 1px solid #f4d0d9;
  }
  .w_2{
    width: 6%;
  }
  .w_1{
    width: 4%;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/gileadSales/mktSales.vue